<template>
	<div>
		<van-steps :active="step_active" active-icon="success" active-color="#ff976a">
			<van-step>{{translate('history_options')}}</van-step>
			<van-step>{{translate('history_rsswithdrawal_amount')}}</van-step>
			<van-step>{{translate('history_accounts_receivable')}}</van-step>
			<van-step>{{translate('history_moderated')}}</van-step>
		</van-steps>

		<div v-for="(item, index) in currencys" :key="index" 
			style="padding: 15px 10px;
				background: #fff;
				margin: 10px;
				border-radius: 5px;
				display:flex;align-items: center"
			@click="goAmount(index)">

			<van-image :src="item.image" width="60" height="60"></van-image>
			<p style="color: #666;padding-left: 15px;font-weight: bold">{{translate('history_extract')}}{{ item.name }}</p>
		</div>

		<div style="padding: 15px 10px;background: #fff;margin: 10px;border-radius: 5px;display:flex;align-items: center"
			@click="goOther()">
			<van-image :src="require('@/assets/images/other.png')" width="60" height="60"></van-image>

			<p style="color: #666;padding-left: 15px;font-weight: bold">其它业务</p>
		</div>

		<div class="common_block">
			<p style="text-align: center;color: blue;" @click="goHistory">{{translate('history_rsswithdrawal_record')}}</p>
		</div>

		<div class="common_block">
			<h5 style="margin: 30px 0 10px 0">{{translate('history_rsswithdrawal_tips')}}</h5>
			<div class="description" v-html="withdraw_tip"></div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'rsswithdraw_index',
		data() {
			return {
				step_active: 0,

				token: "",
				withdraw_tip: "",

				currencys: []
			}
		},
		mounted() {
			if (this.$route.query.token == "" || this.$route.query.token == undefined) {
				this.$router.replace('/nologin')
			} else {
				this.token = this.$route.query.token

				this.$axios({
					method: 'post',
					url: 'rss_withdraw/currency', 
					data: {
						token: this.token
					}
				}).then ((res) => {
					if (res.success) {
						this.currencys = res.data.currencys
						this.withdraw_tip = res.data.withdraw_tip
					}
				})
			}
		},
		methods: {
			goHistory() {
				this.$router.push('/rsswithdraw/history?token=' + this.token)
			},
			goAmount(index) {

				window.sessionStorage.setItem('c', this.currencys[index]['currency_id'])
				window.sessionStorage.setItem('c_name', this.currencys[index]['name'])

				this.$router.push('/rsswithdraw/amount?token=' + this.token)
			},
			goOther() {
				let index = 0
				
				window.sessionStorage.setItem('c', this.currencys[index]['currency_id'])
				window.sessionStorage.setItem('c_name', this.currencys[index]['name'])
				this.$router.push('/rsswithdraw/other?token=' + this.token)
			}
		},
	}
</script>
